import PropTypes from 'prop-types';
import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import RefuseAreaService from '../../services/RefuseAreaService';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';

class RefuseAreaListContainer extends BaseListContainer {
	constructor(props) {
		super(props, new RefuseAreaService());
		this.state = {
			list: [],
			loading: true,
			size: 0,
			first: 0,
			criteria: this.getCleanSearchCriteria(),
			statusOptions: [],
			roleTypeOptions: [],
		};
	}

	updateSearchCriteria(criteria) {
		return {
			name: criteria.name,
			firstResult: criteria.firstResult,
			maxResult: criteria.maxResult,
			sortField: criteria.sortField,
			sortAsc: criteria.sortAsc,
		};
	}

	getCleanSearchCriteria() {
		return {
			name: '',
			firstResult: 0,
			maxResult: 10,
			sortField: 'name',
			sortAsc: true,
		};
	}

	initializeFromBackend() {
		this.enumService
			.getEnumList('UserActivityStatus')
			.then((statusOptions) =>
				this.setState({
					statusOptions,
				})
			)
			.catch(() => {
				this.showErrorMessage('Nie udało się pobrać listy statusów');
			});
	}

	getCriteriaName() {
		return 'refuse-area-list-sc';
	}

	getContainerListName() {
		return 'refuse-area-list-container';
	}

	renderCriteria() {
		return (
			<div className='row'>
				<CriteriaTextComponent
					id='name-sc'
					name='name'
					label={'Nazwa'}
					colClass='col-12'
					value={this.state.criteria.name}
					onChange={this.handleChangeSc}
					validator={this.validator}
				/>
			</div>
		);
	}

	prepareColumns() {
		return [
			{ field: 'name', header: 'Nazwa', sortable: true },
			{
				key: 'actions',
				header: 'Szczegóły',
				body: this.actionTemplate,
				className: 'table-column-action',
			},
		];
	}

	prepareHeaderItems() {
		return this.isUserInAnyRole('ROLE_REFUSE_AREA_MANAGE', 'ROLE_ADMIN_SUPER_MANAGE')
			? [
				{
					label: 'Nowy obszar',
					href: this.props.newUrl,
					type: 'BUTTON',
					className: 'float-right',
					variant: 'yellow',
					iconName: 'mdi-plus',
					iconSide: 'left',
					iconColor: 'white',
				},
			]
			: [];
	}

	render() {
		return (
			<div className='container-fluid'>
				<BreadcrumbsItem to='/refuse-area-list'>{'Lista obszarów'}</BreadcrumbsItem>
				{this.renderView()}
			</div>
		);
	}
}

RefuseAreaListContainer.defaultProps = {
	detailUrl: '/#/refuse-area/details',
	newUrl: '/#/refuse-area/create',
};

RefuseAreaListContainer.propTypes = {
	detailUrl: PropTypes.string,
	newUrl: PropTypes.string,
};

export default RefuseAreaListContainer;
